import { z } from "zod";
import {
  cursorPaginatedResponseSchema,
  DateSchema,
  IdSchema,
  NameSchema,
  NonNegativeNumber,
  NoteSchema,
} from "./commonSchema";
import type { CursorPaginatedResponse } from "@/types/common";

export const ChargeSchema = z.object({
  id: IdSchema,
  createdBy: IdSchema,
  amount: NonNegativeNumber,
  note: NoteSchema,
  createdAt: DateSchema,
  updatedAt: DateSchema,
  deletedAt: DateSchema.nullable(),
  createdByName: NameSchema,
});

export type Charge = z.infer<typeof ChargeSchema>;

export const ChargeListItemSchema = ChargeSchema.pick({
  id: true,
  createdBy: true,
  amount: true,
  note: true,
  createdAt: true,
  deletedAt: true,
  createdByName: true,
});

export type ChargeListItem = z.infer<typeof ChargeListItemSchema>;

export type ChargeListResponse = CursorPaginatedResponse<ChargeListItem>;

export const ChargeListResponseSchema = cursorPaginatedResponseSchema(ChargeListItemSchema);

export const CreateChargeSchema = z.object({
  amount: z.coerce
    .number({ required_error: "errors.validation.cash.required" })
    .min(0, "errors.validation.cash.mustBePositive"),
  note: NoteSchema,
});

export type CreateCharge = z.infer<typeof CreateChargeSchema>;

export const ExportChargesResponseSchema = z.object({
  items: z.array(ChargeListItemSchema),
  total: z.coerce.number(),
});

export type ExportChargesResponse = z.infer<typeof ExportChargesResponseSchema>;

export const ChargeStatsSchema = z.object({
  totalCharges: z.coerce.number(),
  totalChargesMonth: z.coerce.number(),
  totalChargesWeek: z.coerce.number(),
  totalChargesDay: z.coerce.number(),
  lastChargeAt: z.string().nullable(),
});

export type ChargeStats = z.infer<typeof ChargeStatsSchema>;
